import { ROUTES } from "@/route/routes.constants";

/** sessionStorage key for return path after login. */
export const POST_LOGIN_REDIRECT_STORAGE_KEY = 'inspectPostLoginPath';

export function normalizeAppReturnPath(raw: string | null | undefined): string {
    const fallback = ROUTES.INSPECTIONS;
    if (!raw?.trim()) {
      return fallback;
    }
    let path = raw.trim();
    try {
      path = decodeURIComponent(path);
    } catch {
      return fallback;
    }
    path = path.trim();
    if (!path.startsWith('/') || path.startsWith('//')) {
      return fallback;
    }
    if (path.includes('://')) {
      return fallback;
    }
    return path;
  }